module.exports = __webpack_public_path__ + "img/svg/background-create-match-modal.df09b34c4c403d7013bfdd40f8e7bb10.svg";